/*@flow*/
import type { Element } from 'react';
import React from 'react';
import log from 'lib/log';
import useCachedQuery from 'lib/useCachedQuery';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import format from 'date-fns/format';
import compareAsc from 'date-fns/compareAsc';
import * as I from 'immutable';

type PropsT = { streetscapeAssetId: ID };

const GetReportedIssues = (gql(`
  query getReportedIssues($streetscapeAssetId: ID!) {
    me {
      id
      company {
        id
        streetscapeAsset(id: $streetscapeAssetId) {
          streetscapeIssues {
            category
            status
            createdAt
            pageId
          }
        }
      }
    }
  }
`): DocumentNode);

const Component = (props: PropsT): null | Element<'div'> | Element<'table'> => {
  const o = { variables: props };
  const { data, loading } = useCachedQuery(GetReportedIssues, o);

  const path = ['me', 'company', 'streetscapeAsset', 'streetscapeIssues'];
  const issues = I.getIn(data, path, []);

  if (loading) return <div>Loading...</div>;
  if (issues.length === 0) return null;

  // Somehow the array is frozen. (Maybe by the GraphQL client.)
  const unfrozenIssues = [...issues];
  return (
    <table className="table table-small" style={{ marginTop: 10 }}>
      <thead>
        <tr>
          <th colSpan={3}>Streetscape Issues</th>
        </tr>
        <tr>
          <th>Issue Type</th>
          <th>Status</th>
          <th>Reported At</th>
        </tr>
      </thead>
      <tbody>
        {unfrozenIssues
          .sort((a, b) => compareAsc(a.createdAt, b.createdAt))
          .map((v, i) => {
            let time = null;
            try {
              const o2 = { awareOfUnicodeTokens: true };
              time = format(
                new Date(v.createdAt),
                'MMMM do, YYYY - h:mm a',
                o2
              );
            } catch (e) {
              log.error(`This is not a valid time: ${v.createdAt}`);
            }
            return (
              <tr key={i}>
                <td>
                  <a
                    href={`/page/${v.pageId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {v.category}
                  </a>
                </td>
                <td>{v.status}</td>
                <td>{time}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};
export default Component;
